import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { DRAWER } from "../../lib/redux/slices/appSlice";
import { Grid } from "../grid/Grid";
import { Button, Divider, Typography } from "@mui/material";
import { SPACING } from "../../data/spacing";
import { motion } from "framer-motion";

export default function TemporaryDrawer() {
  const { drawer } = useSelector((state) => state.appSlice);
  const dispatch = useDispatch();

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
    size: false,
    content: false,
  });

  useEffect(() => {
    dispatch(
      DRAWER({
        top: false,
        left: false,
        bottom: false,
        right: false,
        title: null,
        content: null,
        size: 500,
      })
    );
  }, []);

  useEffect(() => {
    if (!drawer) {
      setState({
        top: false,
        left: false,
        bottom: false,
        right: false,
        size: null,
        content: null,
      });
    } else {
      setState(drawer);
    }
  }, [drawer]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    dispatch(
      DRAWER({
        [anchor]: open,
      })
    );
    // setState({ ...state, [anchor]: open });
  };
  const list = (anchor) => (
    <Grid
      sx={{
        width:
          anchor === "top" || anchor === "bottom"
            ? "auto"
            : drawer.size
            ? drawer.size
            : 390,
        height: drawer.bottom ? "90vh" : "100%",
      }}
      role="presentation"
      p={SPACING.SMALL}
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography varinat="body1" color="primary">
          {drawer.title}
        </Typography>
        <Button
          color="error"
          onClick={() => {
            dispatch(
              DRAWER({
                top: false,
                left: false,
                bottom: false,
                right: false,
                title: null,
                content: null,
                size: null,
              })
            );
          }}
        >
          برگشت
        </Button>
      </Grid>
      <Divider />
      <Grid py={SPACING.SMALL}>
        <motion.div
          initial={{ opacity: 0, y: -40 }} // Initial animation values
          animate={{ opacity: 1, y: 0 }} // Animation when component is mounted
          exit={{ opacity: 0, y: -40 }} // Animation when component is unmounted
          transition={{ duration: 0.5 }} // Animation duration
        >
          {drawer?.content}
        </motion.div>
      </Grid>{" "}
    </Grid>
  );

  return (
    <div>
      {["left", "right", "top", "bottom"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
